import {
  Sun,
  Cloud,
  Cloudy,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
} from 'lucide-react';

/** Maps an Open-Meteo weather code to a matching Lucide icon. */
export const WeatherIcon = ({ code }: { code: number }) => {
  if (code === 0) return <Sun className="h-4 w-4 text-yellow-500" />;
  if (code >= 1 && code <= 2) return <Cloud className="h-4 w-4 text-gray-400" />;
  if (code === 3) return <Cloudy className="h-4 w-4 text-gray-500" />;
  if (code >= 45 && code <= 48) return <CloudFog className="h-4 w-4 text-gray-400" />;
  if (code >= 51 && code <= 57) return <CloudDrizzle className="h-4 w-4 text-blue-400" />;
  if (code >= 61 && code <= 67) return <CloudRain className="h-4 w-4 text-blue-500" />;
  if (code >= 71 && code <= 77) return <CloudSnow className="h-4 w-4 text-blue-200" />;
  if (code >= 80 && code <= 82) return <CloudRain className="h-4 w-4 text-blue-500" />;
  if (code >= 85 && code <= 86) return <CloudSnow className="h-4 w-4 text-blue-200" />;
  if (code >= 95) return <CloudLightning className="h-4 w-4 text-yellow-600" />;
  return <Cloud className="h-4 w-4 text-gray-400" />;
};

export default WeatherIcon;
